import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../../config/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function BlogMetaTagsDetailComponent() {
  const { Id } = useParams();
  const navigate = useNavigate();
  const [metaTag, setMetaTag] = useState({});
  const [file, setFile] = useState(null);  // For file upload

  useEffect(() => {
    console.log("ID:", Id); // Add this to log the ID to check if it's correct
    const fetchMetaTag = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/get_meta_blog.php?id=${Id}`);
        console.log(response.data); // Add this to see the response
        if (response.data.success) {
          const { created_at, updated_at, deleted_at, ...data } = response.data.metaTag;
          setMetaTag({ ...data, blog_id: Id });
        } else {
          toast.error(response.data.message || 'Failed to fetch meta tag details.');
        }
      } catch (error) {
        toast.error('An error occurred while fetching the meta tag.');
        console.error(error); // Add this to log the error
      }
    };
  
    fetchMetaTag();
  }, [Id]);
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMetaTag((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpdate = async () => {
    const formData = new FormData();

    // Append form fields
    Object.keys(metaTag).forEach((key) => {
      formData.append(key, metaTag[key]);
    });

    // Append file if selected
    if (file) {
      formData.append('og_image', file);
    }

    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/update_meta_tag.php`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.success) {
        toast.success('Meta tag updated successfully!');
        navigate('/admin/blog');
      } else {
        toast.error(response.data.message || 'Failed to update meta tag.');
      }
    } catch (error) {
      toast.error('An error occurred while updating the meta tag.');
    }
  };

  return (
    <div className="container">
      <h1>Edit Meta Tag</h1>
      <form>
        {/* Hidden fields */}
        <input type="hidden" name="blog_id" value={metaTag.blog_id || ''} />

        {Object.keys(metaTag)
          .filter((key) => !['created_at', 'updated_at', 'deleted_at', 'blog_id'].includes(key))
          .map((key) => (
            <div key={key} className="form-group">
              <label>{key.replace(/_/g, ' ').toUpperCase()}:</label>
              <input
                type="text"
                name={key}
                value={metaTag[key] || ''}
                onChange={handleChange}
                placeholder={`Enter ${key.replace(/_/g, ' ')}`}
              />
            </div>
          ))}

        {/* ✅ Add file upload field */}
        <div className="form-group">
          <label>OG Image:</label>
          <input type="file" name="og_image" onChange={handleFileChange} />
        </div>

        <button type="button" onClick={handleUpdate}>Update</button>
      </form>

      <ToastContainer />
    </div>
  );
}

export default BlogMetaTagsDetailComponent;
